import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/shared/auth';
import { reportsEnabledFor } from '../lib/reportsEnabled';

/** Sends the user to the dashboard when the selected account does not have Reports turned on. */
export const ReportsEnabledRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { account } = useAuth();
  if (!reportsEnabledFor(account)) return <Navigate to="/dashboard" replace />;
  return <>{children}</>;
};
